import { SearchHistory } from "../axios";
import { SearchLogHistory } from "../axios";

/**
 * 値関連のutilクラス。
 */
export class ValueUtils {

	/**
	 * バイト数を見やすい表記に変換する。
	 * 
	 * @param value 
	 * @returns 
	 */
	static fromByte(value?: number): string {
		if (value === undefined) {
			return '';
		}
		if (value < 1024) {
			return `${value}B`;
		} else if (value < 1024 * 1024) {
			return (Math.round(value / (1024) * 10) / 10) + "KB";
		} else if (value < 1024 * 1024 * 1024) {
			return (Math.round(value / (1024 * 1024) * 10) / 10) + "MB";
		} else {
			return (Math.round(value / (1024 * 1024 * 1024) * 10) / 10) + "GB";
		}
	}

	/**
	 * 結合ステータス名を返す。
	 * 
	 * @param status 
	 * @returns 
	 */
	static getCombineStatusName(status?: string) {
		switch (status) {
			case '0':
				return '未作成';
			case '1':
				return '作成中';
			case '2':
				return '作成済';
			default:
				return '';
		}
	}

	/**
	 * ダウンロードステータス名を返す。
	 * 
	 * @param status 
	 * @returns 
	 */
	static getDownloadStatusName(status?: string) {
		switch (status) {
			case '0':
				return '未';
			case '1':
				return '済';
			default:
				return '';
		}
	}

	/**
	 * 条件内容を文字列にして返す。
	 * 
	 * @param search 
	 * @returns 
	 */
	static getConditionMessage(search?: SearchHistory) {

		if (search == undefined) {
			return [];
		}

		let messages: string[] = [];
		if (search.send_date_from != undefined || search.send_date_to != undefined) {
			messages.push(`送信日: ${search.send_date_from ?? ''} ～ ${search.send_date_to ?? ''}`);
		}
		if (search.issued_date_from != undefined || search.issued_date_to != undefined) {
			messages.push(`発行日: ${search.issued_date_from ?? ''} ～ ${search.issued_date_to ?? ''}`);
		}
		if (search.customer != undefined) {
			messages.push(`取引先: ${search.customer ?? ''}`);
		}
		if (search.doc_name != undefined) {
			messages.push(`文書名: ${search.doc_name ?? ''}`);
		}
		if (search.file_name != undefined) {
			messages.push(`ファイル名: ${search.file_name ?? ''}`);
		}
		if (search.amount_from != undefined || search.amount_to != undefined) {
			messages.push(`金額: ${search.amount_from?.toLocaleString() ?? ''} ～ ${search.amount_to?.toLocaleString() ?? ''}`);
		}
		if (search.search_key_1 != undefined) {
			messages.push(`検索キー１: ${search.search_key_1 ?? ''}`);
		}
		if (search.search_key_2 != undefined) {
			messages.push(`検索キー２: ${search.search_key_2 ?? ''}`);
		}
		if (search.search_key_3 != undefined) {
			messages.push(`検索キー３: ${search.search_key_3 ?? ''}`);
		}

		return messages;
	}

		/**
	 * ログ条件内容を文字列にして返す。
	 * 
	 * @param search 
	 * @returns 
	 */
		static getConditionLogMessage(search?: SearchLogHistory) {

			if (search == undefined) {
				return [];
			}
	
			let messages: string[] = [];
			if (search.create_date_from != undefined || search.create_date_to != undefined) {
				messages.push(`作成日: ${search.create_date_from ?? ''} ～ ${search.create_date_to ?? ''}`);
			}
	
			return messages;
		}
}